// Utility to build a combined key for identifying a surface or module using the type and key
export var buildCombinedKey = function buildCombinedKey(type, key) {
  return "".concat(type, ",").concat(key);
};